import React from 'react'
import { Sparkles } from 'lucide-react'

export function Footer() {
  const quickLinks = [
    { name: 'Features', href: '#features' },
    { name: 'Use Cases', href: '#use-cases' },
    { name: 'How It Works', href: '#how-it-works' },
  ]
  const currentYear = new Date().getFullYear()

  return (
    <footer className="relative bg-gradient-to-br from-slate-50 to-blue-50 dark:from-slate-900 dark:to-slate-800 border-t border-border/50">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-indigo-500/20 to-transparent"></div>
      <div className="container mx-auto max-w-[1200px] px-10 md:px-[72px]">
        <div className="py-12 lg:py-16">
          <div className="grid sm:grid-cols-2 gap-8 lg:gap-12 items-start">
            <div className="space-y-4 text-center lg:text-left">
              <div className="flex items-center justify-center sm:justify-start space-x-3">
                <Sparkles className="h-12 w-12 text-indigo-500 animate-pulse" />
                <div className="space-y-1 text-left">
                  <span className="text-lg font-semibold bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent">AIRA</span>
                  <p className="text-sm text-muted-foreground">Your everyday AI sidekick.</p>
                </div>
              </div>
            </div>
            <div className="text-center lg:text-right">
              <h3 className="font-semibold text-foreground mb-4">Quick Links</h3>
              <nav className="flex flex-wrap items-center justify-center lg:justify-end gap-6">
                {quickLinks.map((link) => (
                  <a key={link.name} href={link.href} className="text-muted-foreground hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors duration-200 hover:underline underline-offset-4">
                    {link.name}
                  </a>
                ))}
              </nav>
            </div>
          </div>
        </div>
        <div className=" pb-10">
          <hr className='bg-[#717182]/50 h-0.2 w-full my-6 '/>
          <div className="flex flex-col sm:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-sm text-muted-foreground">© {currentYear} Quantum Leap. All rights reserved.</p>
            <div className="flex items-center space-x-4 text-sm text-muted-foreground">
              <a href="#" className="hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors duration-200">Privacy Policy</a>
              <span>•</span>
              <a href="#" className="hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors duration-200">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}


